import { createStore } from 'vuex';

export default createStore({
  state: {
    collapsedMenu: JSON.parse(localStorage.getItem('collapsedMenu')) || false,
    sessionExpired: false, 
  },
  mutations: {
    toggleMenu(state) {
      state.collapsedMenu = !state.collapsedMenu;
      localStorage.setItem('collapsedMenu', JSON.stringify(state.collapsedMenu));
    },
    setSessionExpired(state, value) {
      state.sessionExpired = value;
    }
  },
});